import axios from 'axios'
export default {
    getConfig() {
        return axios.get('/v1/config/get-config')
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    updateConfig(datas) {
        return axios.post('/v1/config', datas)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getConfigListPromotionVD(datas) {
        var menu = (datas && datas.menu) ? datas.menu : '';
        var code = (datas && datas.code) ? datas.code : '';
        return axios.get('/config/change-createby/'+ menu + '?user=' + code)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    updateConfigChangeCreateby(menu, datas) {
        return axios.post('/config/change-createby/'+ menu, datas)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
}